import { Skeleton } from '@mantine/core';

function GamecenterPlayerCardSkeleton() {
  return <Skeleton height={220} /* eslint-disable-line local-rules/use-theme-tokens */ radius={8} />;
}

export default GamecenterPlayerCardSkeleton;
